<template>
  <div class="ut-fh">
    <div class="ut-flex" style="margin-top: 10px">
      <h4 style="font-weight: bold">{{ $dft.capHead($t("order_lines")) }}</h4>
      <img
        style="margin-top: 4px"
        @click="(e) => onClickEditIcon(e)"
        src="static/icons/edit-blue.svg"
        class="dt-icon v5 s1"
      />
    </div>
    <div
      :style="{
        height: `${
          this.list.length <= 10
            ? ((this.list.length === 0 ? 1 : this.list.length) + 1) * 52
            : 11 * 52
        }px`,
      }"
    >
      <NTable
        class="dbox1"
        id="distribution-order-sidewindow-backorder"
        :config="tableConfig"
        :headers="Headers"
        :items="list"
      >
        <template v-slot:thead="{ thcon, thtext }">
          <tr style="color: var(--text-5)">
            <th v-bind="thcon('product')">
              <div class="ut-fc">
                <span>{{ $t("catalog_no") }} </span>
                <span>{{ $t("barcode") }}</span>
              </div>
            </th>
            <th v-bind="thcon('title1')">
              <div class="ut-fc">
                <span>{{ $t("artist") }}</span>
                <span>{{ $t("ps_title") }}</span>
              </div>
            </th>
            <th v-bind="thcon('format')">
              <div class="ut-fc">
                <span>{{ $t("label") }}</span>
                <span>{{ $t("Format") }}</span>
              </div>
            </th>
            <th v-bind="thcon('quantity')">
              <span class="ut-text-right"> {{ $t("quantity") }}</span>
            </th>
            <th v-bind="thcon('vat_rate')">
              <span class="ut-text-right"> {{ $t("vat_rate") }}</span>
            </th>
            <th v-bind="thcon('total')">
              <span class="ut-text-right"> {{ thtext("total") }}</span>
            </th>
          </tr>
        </template>
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('product')">
              <div class="ut-flex">
                <div class="circular-status">
                  <div
                    class="circular-status-color"
                    style="
                      width: 16px;
                      height: 16px;
                      border-radius: 50%;
                      margin-right: 8px;
                    "
                    :style="{
                      'background-color': `#${item['label_status_colour']}`,
                      border: item['label_status_colour']
                        ? `1px solid #${item['label_status_colour']}`
                        : '1px solid gray',
                    }"
                  ></div>
                </div>

                <div class="ut-fc ut-txtov">
                  <span class="ut-txtov" :title="item['catalog_no']">
                    {{ item["catalog_no"] }}
                  </span>
                  <span class="ut-txtov" :title="item['barcode']">
                    {{ item["barcode"] }}
                  </span>
                </div>
              </div>
              <!-- <span>{{item['catalog_no']}}</span> -->
            </td>
            <td v-bind="tdcon('title1')">
              <div class="ut-fc ut-txtov">
                <span class="ut-txtov" :title="item['release_alt_artist']">{{
                  item["release_alt_artist"]
                }}</span>
                <span class="ut-txtov" :title="item['release_alt_title']">{{
                  item["release_alt_title"]
                }}</span>
              </div>
            </td>
            <td v-bind="tdcon('format')">
              <div class="ut-fc ut-txtov">
                <span class="ut-txtov" :title="item['label_name']">
                  {{ item["label_name"] }}
                </span>
                <span class="ut-txtov" :title="item['format_name']">
                  {{ item["format_name"] }}
                </span>
              </div>
            </td>
            <td v-bind="tdcon('quantity')">
              <span>{{ item["order_qty"] }}</span>
            </td>
            <td v-bind="tdcon('vat_rate')">
              <span>{{ item["vat_rate"] }}</span>
            </td>
            <td v-bind="tdcon('total')">
              <span>{{ item["total"] }}</span>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <!-- <div class="ut-fc" style="margin-top: 20px; margin-right: 10px">
      <div class="ut-flex ut-jend" >
        <OrderKVSummary :selectedOrder="selectedOrder" />
      </div>
      <div class="ut-flex ut-jend ut-text-secondary">
        <DTCheckbox
          :id="'ready_to_ship'"
          :label="$t('ready_to_ship')"
          :checked="
            isChecked(
              selectedOrder &&
                selectedOrder.order_details_tab_summary &&
                selectedOrder.order_details_tab_summary.order &&
                selectedOrder.order_details_tab_summary.order['ready_to_ship']
            )
          "
          :h="'24px'"
          :minH="'24px'"
          :class="'ml0'"
          :style="'margin-right: 0px'"
          @click="onReadyToShipClicked"
        />
      </div>
    </div> -->
  </div>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import { OrderService } from "../../services/order.service";
import { isChecked } from "../../../../utility";
import OrderKVSummary from "./order-kv-summary.vue";

export default {
  props: {
    selectedOrder: {
      type: Object,
    },
  },
  components: {
    NTable,
    DBox,
    DTCheckbox,
    OrderKVSummary,
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        headerHeight: 52,
        rowHeight: 52,
      }),
    };
  },
  computed: {
    Headers: function () {
      return [
        createTableHeader("product", {}),

        createTableHeader("title1", { text: this.$t("title") }),
        createTableHeader("format", { mw: 100 }),

        createTableHeader("quantity", { ta: "right", mw: 100 }),
        createTableHeader("vat_rate", { ta: "right", mw: 100 }),
        createTableHeader("total", { ta: "right", mw: 100 }),
      ];
    },
    order() {
      return this.selectedOrder?.order_details_tab_summary?.order || {};
    },
    order_id() {
      return this.order?.order_id;
    },
    list: function () {
      return this.selectedOrder?.order_details_tab_summary?.orderlines || [];
    },
    discount_amount() {
      return +(
        +this.selectedOrder?.order_details_tab_summary?.orderObj?.order_value *
        ((this.selectedOrder?.order_details_tab_summary?.order?.order_discount /
          100) *
          -1)
      );
    },
    total_cost() {
      return (
        +this.selectedOrder?.order_details_tab_summary?.orderObj?.order_value +
        +this.selectedOrder?.order_details_tab_summary?.order?.shipping_costs +
        +this.discount_amount
      );
    },
  },

  methods: {
    isChecked: isChecked,

    onDocumentClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "documents_modal",
          order_id: this.order_id,
        },
      });
    },
    onNotifyClick: async function () {
      NotificationService.showNotification({
        text: "Sending Request ...",
        timeout: 2000,
        type: "normal",
      });
      const resData = await OrderService.shippingNotify(
        this.order_id,
        0,
        "DHL"
      );
    },
  
    onClickEditIcon: function () {
      //console.log("document.getElementById('document')",document.getElementById('deliveryInfoDiscount'))
      document.getElementById("orderLine").scrollIntoView({
        behavior: "smooth",
      });
    },

    onClickEditShippingCosts: function () {
      //console.log("document.getElementById('document')",document.getElementById('deliveryInfoDiscount'))
      document.getElementById("shipping").scrollIntoView({
        behavior: "smooth",
      });
    },
    onClickEditDiscount: function () {
      document.getElementById("deliveryInfoDiscount").scrollIntoView({
        behavior: "smooth",
      });
    },
    onReadyToShipClicked: function (event) {
      this.$emit("shipClick", event.target.checked);
    },
  },
};
</script>
<style lang="scss">
.cmp-distribution-order-sidewindow-orderline {
  .dt-ntable {
    // --ntable-height: 170px;
  }
}
</style>
